import React from 'react';
import { FacebookIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
const columns = [{
  title: 'Services',
  links: ['Ordures et matières résiduelles', 'Service de la voirie', 'Service incendie', 'L’aqueduc', 'Fosse septique']
}, {
  title: 'Vie municipale',
  links: ['Nos élus', 'Ordres du jour', 'Procès-verbaux', 'Rapport financier', 'Avis publics']
}, {
  title: 'Citoyens',
  links: ['Évaluation et taxes', 'Baux de villégiature', 'Urbanisme et réglementation', 'Bibliothèque', 'Formulaire']
}];
export function Footer() {
  return <footer className="bg-ville-navy text-white" data-id="element-1553" data-mp="3qdf2v2jeis8j">
      <div className="mx-auto max-w-[1400px] px-5 py-16 lg:px-10" data-id="element-1554" data-mp="3qc3yp1m1nigw">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_repeat(3,1fr)]" data-id="element-1555" data-mp="29ynlrlrph7ej">
          <div data-id="element-1556" data-mp="2eya05yj9stox">
            <Logo variant="light" data-id="element-1557" data-mp="2ey05hxna5ycw" />
            <address className="mt-6 space-y-3 text-sm not-italic text-white/80" data-id="element-1558" data-mp="2ez1ja9vokyyb">
              <p className="flex items-start gap-3" data-id="element-1559" data-mp="3l8qy89n2utu3">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-ville-lime" aria-hidden="true" data-id="element-1560" data-mp="3lbdces4h47la" />
                28, route 138, Baie-Trinité (Québec) G0H 1A0
              </p>
              {/*
                La Municipalité ne publie ni numéro de téléphone ni adresse courriel sur
                son site : on renvoie au formulaire, plutôt que d'inventer des coordonnées.
               */}
              <p className="flex items-center gap-3" data-id="element-1561" data-mp="80nskgzggmbt">
                <MailIcon className="h-4 w-4 shrink-0 text-ville-lime" aria-hidden="true" data-id="element-1562" data-mp="32w45wy0ricd" />
                <a href="#accueil" className="hover:text-white" data-id="element-1563" data-mp="hrs6rehb435l">
                  Nous contacter — formulaire en ligne
                </a>
              </p>
            </address>
            <ul className="mt-6 flex items-center gap-2" data-id="element-1564" data-mp="qt8flhsh3x7p">
              <li data-id="element-1565" data-mp="qtrsgk39nvev">
                <a href="#accueil" aria-label="Suivre la Municipalité de Baie-Trinité sur Facebook" className="grid h-11 w-11 place-items-center rounded-full border border-white/30 transition-colors duration-150 ease-ville hover:bg-white hover:text-ville-navy" data-id="element-1566" data-mp="mrwp7a1rz7yg">
                  <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-1567" data-mp="13t0t4ejet6vq" />
                </a>
              </li>
            </ul>
          </div>

          {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-1568" data-mp="1clumtgzls8t4">
              <h2 className="text-sm font-bold uppercase tracking-wider text-ville-lime" data-id="element-1569" data-mp="1cnp0ca8joyn6">{column.title}</h2>
              <ul className="mt-5 space-y-3" data-id="element-1570" data-mp="1hmif05zkivox">
                {column.links.map(link => <li key={link} data-id="element-1571" data-mp="1mhpaiqioou2r">
                    <a href="#accueil" className="text-sm text-white/80 transition-colors duration-150 ease-ville hover:text-white" data-id="element-1572" data-mp="1rjeq8jgupvx6">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>
      </div>

      <div className="border-t border-white/15" data-id="element-1573" data-mp="2ah860yqtbewk">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-6 gap-y-2 px-5 py-5 text-xs text-white/60 lg:px-10" data-id="element-1574" data-mp="25o5cgqm1c5gd">
          <p data-id="element-1575" data-mp="21n1sbrwyfn9c">© 2026 Municipalité de Baie-Trinité</p>
          <a href="#accueil" className="hover:text-white" data-id="element-1576" data-mp="1wo8pctfanenf">
            Espace vie privée
          </a>
          <a href="#accueil" className="hover:text-white" data-id="element-1577" data-mp="2te9cyp3xfp35">
            Conditions d’utilisation
          </a>
          <a href="#accueil" className="hover:text-white" data-id="element-1578" data-mp="2pdfnvser048o">
            Charte éthique de l’IA
          </a>
          <p className="ml-auto" data-id="element-1579" data-mp="2kc0381ghfzqt">MRC de Manicouagan · Côte-Nord</p>
        </div>
      </div>
    </footer>;
}